var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass: "col navbars_jhi stick-top",
        staticStyle: { "transition-duration": "0.5s" },
        attrs: { id: "message" },
      },
      [_c("jhi-navbars")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col",
        staticStyle: {
          padding: "0px",
          "max-height": "100vh",
          overflow: "auto",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: { position: "sticky", "z-index": "1" },
            attrs: { id: "app-header" },
          },
          [_c("jhi-navbar")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "container-fluid",
            staticStyle: { "max-width": "1960px", margin: "auto !important" },
          },
          [_c("div", { staticClass: "card jh-card" }, [_c("app-main")], 1)]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }